import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import SportPageImpl from './sport-page.js';

const { UIPage } = MojitoCore.Presentation;

/**
 * @namespace SportPage
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * Page that displays sports.
 *
 * @class SportPage
 * @memberof Mojito.Applications.Sports.Pages.SportPage
 */

/**
 * SportPage prop types.
 *
 * @property {node} [children] - Child components rendered inside the sport page (typically a nested Router with sport sub-views).
 *
 * @memberof Mojito.Applications.Sports.Pages.SportPage
 */
const propTypes = {
    children: PropTypes.node,
};

export default UIPage('SportPage', SportPageImpl, propTypes);
